import { get } from '../../../util/api'
import { createChangeTableSettingAction } from '../../form/state/table-state-helper'
import * as type from './type'
import * as tableAction from '../../table/state/action'
import {selectOwnState, selectTable} from './selector'
import {TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT, TABLE_PROCESS_WORKLIST} from "./type";

export const initialTableQuery = tableAction.createInitialTableQueryAction(selectOwnState, type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const changeFilter = tableAction.createChangeFilterAction(selectOwnState, type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const toggleSort = tableAction.createToggleSortAction(selectOwnState, type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const toggleMultiSort = tableAction.createToggleMultiSortAction(selectOwnState, type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const gotoPage = tableAction.createGotoPageAction(type.TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const initialColumnsVisibility = tableAction.createInitialColumnsVisibilityFormHandler(TABLE_PROCESS_WORKLIST, type.CHANGE_TABLE_SETTING)

export const initialTableSettingsAllOpenTask = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const toggleColumnVisibilityAllOpenTask = tableAction.createToggleColumnVisibilityTableHandler(selectTable, TABLE_ALL_OPEN_TASK_WITH_ATTACHMENT)

export const changeTableSetting = createChangeTableSettingAction(type.CHANGE_TABLE_SETTING)


export const findTaskListWithAttachmentRequest = () => ({
    type: type.FIND_TASK_LIST_WITH_ATTACHMENT_REQUEST,
    payload: {},
})

export const findTaskListWithAttachmentSuccess = (taskListWithAttachment) => ({
    type: type.FIND_TASK_LIST_WITH_ATTACHMENT_SUCCESS,
    payload: {
        taskListWithAttachment,
    },
})

export const findTaskListWithAttachmentError = (error) => ({
    type: type.FIND_TASK_LIST_WITH_ATTACHMENT_ERROR,
    payload: {
        error,
    },
})

export const findTaskWithAttachmentList = () => (dispatch, getState) => {
    dispatch(findTaskListWithAttachmentRequest())

    get('/api/process/task/find-open-with-attachment')
        .then(taskList => {
            dispatch(findTaskListWithAttachmentSuccess(taskList))
        })
        .catch(error => {
            dispatch(findTaskListWithAttachmentError(error))
        })
}





// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/state/action.js